import React from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ActionRequest } from '@models/ActionRequest';

type Props = ModalProps & {
  actionRequest: ActionRequest | null;
}

const ActionRequestDetailsModal = ({ actionRequest, ...modalProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal {...modalProps} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{actionRequest?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ whiteSpace: "pre-line" }}>
          {actionRequest?.body}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={modalProps.onHide}>
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { ActionRequestDetailsModal };
